import React from "react"

const Checkbox = ({ checked, indeterminate, onChange, className = "" }) => {
  return (
    <label
      className={`relative flex items-center justify-center cursor-pointer ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        type="checkbox"
        checked={checked}
        ref={(el) => {
          if (el) el.indeterminate = indeterminate
        }}
        onChange={onChange}
        className="sr-only"
      />
      <span
        className={`w-4 h-4 rounded border-2 flex items-center justify-center transition-all ${checked || indeterminate ? "bg-blue-600 border-blue-600" : "bg-white border-gray-300 hover:border-blue-400"}`}
      >
        {indeterminate && !checked && <span className="w-2 h-0.5 bg-white block rounded" />}
        {checked && (
          <svg
            className="w-2.5 h-2.5 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={3}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        )}
      </span>
    </label>
  )
}

export default Checkbox
